import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { mobileBridge } from '../../services/mobile/mobile-bridge';

export const platformGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const isPwa = mobileBridge.isPWA();

    const requiredDevice =
        (route.data?.['device'] as 'web' | 'mobile' | undefined) ??
        (route.routeConfig?.path?.includes('mobile') ? 'mobile' : 'web');

    if (requiredDevice === 'mobile') {
        if (!isPwa) {
            return router.parseUrl('/web');
        }
        return true;
    }

    // requiredDevice === 'web'
    if (isPwa) {
        return router.parseUrl('/mobile');
    }

    return true;
};
